/* tslint:disable:no-http-string */
import React from "react";

function Cross(): JSX.Element {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g
        id="Icons"
        stroke="currentColor"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Utils"
          transform="translate(-380.000000, -100.000000)"
          fill="currentColor"
        >
          <g id="icons" transform="translate(20.000000, 20.000000)">
            <polygon
              id="close-[#1511]"
              points="371.4489 89.9997 380.0029 98.5537 378.5559 99.9997 370.0029 91.4457 361.4489 99.9997 360.0029 98.5537 368.5559 89.9997 360.0029 81.4457 361.4489 79.9997 370.0029 88.5537 378.5559 79.9997 380.0029 81.4457"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export { Cross };
